import {totalAdded, totalSpent} from 'core/LifeCycle';

type ObsoleteBudget = {
  amount: MoneyAmount;
  startDate: DayStartTimeStamp;
  finishDate: DayStartTimeStamp;
};

type ObsoleteCore = CoreState & {
  budget: ObsoleteBudget;
};

export function upgradeBudget(state: ObsoleteCore): Budget {
  const {budget: oldBudget, history} = state;
  const {amount, startDate, finishDate} = oldBudget;

  if (oldBudget.initial) return oldBudget as Budget;
  return {
    initial: Number(amount || 0),
    spent: totalSpent(oldBudget, history),
    added: totalAdded(oldBudget, history),
    startDate,
    finishDate,
  };
}
